import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from "./Base/Layout";

class ReservationCompletePage extends Component {
    render() {
        let {i18n} = this.props;

        let bookingId = this.props.match.params.id;
        return (
            <Layout
                showPromoContent={false}
                title={i18n['reservationCompletePage.title']}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc"
                         style={{minHeight: '400px', userSelect: 'all'}}>
                        {i18n['reservationCompletePage.line1']}
                        <br/>
                        {i18n['reservationCompletePage.line2']}
                        <br/>
                        {i18n['reservationCompletePage.line3']} <b>{bookingId}</b>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationCompletePage);



// WEBPACK FOOTER //
// ./src/components/ReservationCompletePage.js